import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumnWideHalfRemove"><Path d="M2 4V20H12V18.5H3.5V12.75H22V4H2Z" fill="currentColor"/><Path d="M16.75 15.6893L15.6893 16.75L17.9393 19L15.6893 21.25L16.75 22.3107L19 20.0607L21.25 22.3107L22.3107 21.25L20.0607 19L22.3107 16.75L21.25 15.6893L19 17.9393L16.75 15.6893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalfRemove;
